module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "id": "fm01"
    }
  }), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LSO BY")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANCES")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TANI")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FICTION")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Poached Egg on Toast")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Deafening")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Leaning, Leaning Over Water")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Man Without Face")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Pack Ice")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Truth or Lies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POETRY")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A Season of Mourning")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Rentee Bay")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("No Other Lodgings")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHILDREN’S")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Linger by the Sea")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417e2834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 60
// module chunks = 0